import { render } from "./AuthGoogle.vue?vue&type=template&id=7bbcb7aa&scoped=true"
import script from "./AuthGoogle.vue?vue&type=script&lang=js"
export * from "./AuthGoogle.vue?vue&type=script&lang=js"

import "./AuthGoogle.vue?vue&type=style&index=0&id=7bbcb7aa&lang=scss&scoped=true"

import exportComponent from "/builds/optelgroup/exploration/reusable-components/supply-chain-simulator/prototype/iscp-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbcb7aa"]])

export default __exports__